import { render, staticRenderFns } from "./SignatureV1Properties.vue?vue&type=template&id=d7ba750e&"
import script from "./SignatureV1Properties.vue?vue&type=script&lang=js&"
export * from "./SignatureV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports